
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2737',
  depVersions: {
  "customer-portal-app": "static-1.2737",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.484",
  "data-fetching-client": "static-1.9793",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25766",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5726",
  "hs-test-utils": "static-1.8152",
  "hub-http": "static-1.6354",
  "hub-http-shared-msw-handlers": "static-1.10291",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18608",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11604",
  "I18n": "static-7.1641",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6590",
  "payment-link-components": "static-1.23853",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7208",
  "quartz-core": "static-1.6427",
  "quartz-i18n": "static-1.883",
  "react": "static-7.187",
  "react-colorpicker": "static-2.10339",
  "react-dlb": "static-1.81",
  "react-utils": "static-2.5441",
  "reselect": "static-3.6",
  "rich-text-lib": "static-1.20060",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18175",
  "ui-components-test-utils": "static-1.5741",
  "UIComponents": "static-3.8550",
  "foundations-assets": "static-1.5007",
  "foundations-components": "static-1.8196",
  "foundations-theming": "static-1.4565",
  "foundations-theming-specialty": "static-1.2281",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1188",
  "quartz-config": "static-1.986",
  "quartz-routing": "static-1.638",
  "quick-fetch": "static-1.4017",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-feature-id-1459-lcp-embedded-fields.3",
  "rpc-client-utils": "static-1.4789",
  "sanitize-text": "static-1.8279",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4892",
  "ui-addon-react-router-dom": "static-1.9668",
  "usage-tracker": "static-1.7483",
  "usage-tracker-anonymous": "static-1.5900",
  "usage-tracker-core": "static-1.7333",
  "video-components-external": "static-1.11718",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3499",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3485",
  "quartz-webpack": "static-1.3432",
  "bend-plugin-quartz-routing": "static-1.286",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7811",
  "frontend-preferences-client": "static-1.8059",
  "laboratory-lib": "static-3.7284",
  "onboarding-scopes": "static-1.6592",
  "seat-types-lib": "static-1.311",
  "ui-addon-opt": "static-4.8494",
  "HeadJS": "static-2.773",
  "hs-test-utils-bend-plugin": "static-1.3263",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.180",
  "ts-schema": "static-1.4181",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7964",
  "content-media-capture": "static-1.4925",
  "cssUtils": "static-1.831",
  "customer-data-ui-utilities": "static-1.9957",
  "file-manager-components": "static-1.23995",
  "HubStyle": "static-2.11911",
  "knowledge-content-types": "static-1.8559",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.489",
  "ui-addon-emoji-picker": "static-1.10018",
  "ui-addon-i18n": "static-1.11281",
  "ui-business-units-lib": "static-1.9201",
  "ui-shepherd-react": "static-3.10386",
  "video-data-lib": "static-1.35376",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4457",
  "commerce-tours-lib": "static-1.6348",
  "customer-data-properties": "static-1-sbelsky-fix-property-definition-memoization.2",
  "getting-started-shared-tasks": "static-1.18781",
  "growth-onboarding-reliability": "static-1.5213",
  "onboarding-tours": "static-1.16855",
  "reference-resolvers-lite": "static-1.8228",
  "sales-checkout-service-client": "static-1.3723",
  "ui-addon-iframeable": "static-1.9200",
  "user-context": "static-1.5240",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.848",
  "hubspotter-http": "static-1.4750",
  "icons": "static-2.656",
  "mobile-manifest-mixins": "static-1.547",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.883",
  "quartz-head": "static-1.873",
  "quartz-test": "static-1.883",
  "quartz-tracking": "static-1.587",
  "trellis-components": "static-1.2236",
  "ui-fonts": "static-1.866",
  "usage-tracker-container": "static-1.7473",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9555",
  "data-token-picker": "static-1.16642",
  "FileManagerLib": "static-1.39635",
  "property-translator": "static-1.5529",
  "atom": "static-1.5208",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6116",
  "salesImages": "static-1.527",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5679",
  "react-create-root-preference": "static-1.39",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1189",
  "bend-plugin-foundations-components": "static-1.4465",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "trellis-assets": "static-1.2217",
  "bend-plugin-foundations-theming": "static-1.3048",
  "foundations-theming-base": "static-1.3550",
  "stylex": "static-1.35",
  "interframe": "static-3.4891",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5897",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.199",
  "chirp-fetch": "static-1.2020",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4609",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4783",
  "content-media-composition-data-lib": "static-1.12729",
  "content-media-compositions": "static-2.16736",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4282",
  "magpie-lib": "static-1.5642",
  "magpie-types": "static-1.5102",
  "media-bridge-lib": "static-1.19158",
  "bender-build-tools": "static-1.3301",
  "ai-components-ui-library": "static-1.9284",
  "avatar-components": "static-1.2630",
  "calling-global-api": "static-1.64950",
  "calling-internal-common": "static-1.31444",
  "calling-lifecycle-internal": "static-1.66332",
  "calling-lifecycle-messages": "static-1.58626",
  "commerce-products-lib": "static-1.10056",
  "conditional-properties-service-client": "static-1.3897",
  "crm-links": "static-1.6441",
  "crm-message-bus": "static-1.43336",
  "crm-pipelines-api-client-types": "static-1.4236",
  "customer-data-objects-ui-components": "static-1.13161",
  "customer-data-properties-shared-msw-handlers": "static-1.9618",
  "customer-data-property-utils": "static-1.8227",
  "external-options-client-types": "static-1.4226",
  "framework-data-schema-resolvers": "static-1.7026",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.310",
  "hubspot-apollo-client": "static-1.5010",
  "inbound-db-meta-service-client": "static-1.3686",
  "inbound-db-properties-service-client": "static-1.3945",
  "inbounddb-objects-service-types": "static-1.4317",
  "meetings-icalendar-utils-lib": "static-1.765",
  "multi-currency-client-types": "static-1.3790",
  "object-builder-ui-client": "static-1.49206",
  "pipeline-validation-client-types": "static-1.4065",
  "property-value-citations": "static-1-sbelsky-fix-property-definition-memoization.2",
  "pulse": "static-1.737",
  "smart-property-lib": "static-1.7935",
  "tiered-pricing": "static-1.1559",
  "ui-addon-form-validation": "static-1.11123",
  "zustand": "static-1.74",
  "superstore": "static-1.4892",
  "feedback-loader": "static-1.29543",
  "ui-addon-video-player": "static-1.8837",
  "ui-coaching-tips": "static-1.28928",
  "ContentUtils": "static-1.68751",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4558",
  "sassPrefix": "static-1.158",
  "react-dnd-compat": "static-1.4746",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1172",
  "copilot-toolkit": "static-1.11474",
  "navigation-messaging": "static-1.7651",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8308",
  "growth-data-modal": "static-1.5647",
  "onboarding-tours-client": "static-1.5069",
  "growth-onboarding-confetti": "static-1.3198",
  "growth-onboarding-next-action-utils": "static-1.2297",
  "navigation-components": "static-1.18324",
  "onboarding-tours-utils": "static-1.921",
  "ui-shepherd-tracker": "static-1.7767",
  "ui-universal-auth": "static-1.9139",
  "batch-promise": "static-1.1676",
  "getting-started-shared-tasks-store": "static-1.17899",
  "hubspotter-http-shared-msw-handlers": "static-1.10289",
  "usage-tracker-session-replay": "static-1.5169",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1075",
  "tanstack-virtual": "static-1.31",
  "audio-components": "static-1.6120",
  "FileManagerCore": "static-1.39494",
  "FileManagerImages": "static-1.37146",
  "video-components": "static-1.13720",
  "foundations-components-legacy": "static-1.1221",
  "purchase-motions-api": "static-1.6119",
  "signup-constants": "static-1.19186",
  "signup-ui-url-generator": "static-2.8190",
  "usage-tracker-public": "static-1.7294",
  "reactive-lib": "static-1.858",
  "simple-logging-lib": "static-1.3181",
  "chatspot-core": "static-1.21925",
  "calling-error-reporting": "static-1.31451",
  "shared-worker-versioning": "static-1.11167",
  "calling-usage-tracker": "static-1.6676",
  "voice-sms-access-library": "static-1.1486",
  "conversations-skeleton-state": "static-1.7379",
  "customer-data-tracking": "static-1.7018",
  "commerce-permissions": "static-1.908",
  "products-iframe-lib": "static-1.8296",
  "products-ui-components-shared-msw-handlers": "static-1.10673",
  "location-customization-utils-lib": "static-1.9637",
  "restore-request-side-panel-lib": "static-1.1222",
  "fdsr-migration-layer": "static-1.145",
  "framework-builder-read-service-client": "static-1.4104",
  "framework-data-schema-quick-fetch": "static-1.6931",
  "persist-promise": "static-1.3833",
  "event-emitter": "static-1.1082",
  "hubspot-apollo-cache": "static-1.469",
  "bend-plugin-pulse": "static-1.240",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.415",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10374",
  "fsm": "static-1.3864",
  "policy-lib": "static-1.6919",
  "react-tinymce": "static-1.55593",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10437",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54719",
  "tinymce-plugins": "static-1.57833",
  "tinymce-themes": "static-1.56689",
  "growth-onboarding-feedback-components": "static-1.6711",
  "cms-field-types": "static-1.4947",
  "content-icons-ui": "static-1.2265",
  "integrations-lib": "static-1.16572",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.450",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.2198",
  "growth-onboarding-next-action-components": "static-1.2325",
  "user-context-client": "static-1.4711",
  "nest": "static-1.364",
  "unified-auth-core-lib": "static-1.935",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4667",
  "video-embed": "static-1.36210",
  "social-insights-client-types": "static-1.22396",
  "calling-orchestration-schema": "static-1.36263",
  "sales-views-client-types": "static-1.4389",
  "crm-record-cards-service-types": "static-1.3684",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4642",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3175",
  "tinymce-data": "static-1.40804",
  "ui-addon-sales-email": "static-1.5342",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12705",
  "layout-dnd-utils": "static-1.11680",
  "react-codemirror": "static-1.10760",
  "ui-brand-identity-lib": "static-1.15755",
  "NamespacedHubStyle": "static-2.9153",
  "flux-actions": "static-1.348",
  "integrations-error-boundary-lib": "static-1.13987",
  "integrations-tracking-lib": "static-1.5739",
  "native-integrations-shared-strings": "static-1.7913",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10494",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.653",
  "InboxConnectUtils": "static-4.15168",
  "meetings-connect-utils-lib": "static-1.7737",
  "outpost": "static-1.4301",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68826",
  "layout-data-lib": "static-1.10005",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3143",
  "adobe-sign-auth-lib": "static-1.62",
  "ads-unified-auth-lib": "static-1.481",
  "google-sheets-integration-lib": "static-1.625",
  "microsoft-drive-integration-lib": "static-1.782",
  "surveymonkey-integration-lib": "static-1.82",
  "slack-ui-library": "static-1.10529",
  "advanced-menus-core": "static-1.15348",
  "advanced-menus-lib": "static-1.12257",
  "ExportDialog": "static-6.10512",
  "ui-memberships-settings-lib": "static-1.34401",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15347",
  "simple-menus-lib": "static-1.16864"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2737",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.484",
  "data-fetching-client": "/data-fetching-client/static-1.9793",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25766",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5726",
  "hs-test-utils": "/hs-test-utils/static-1.8152",
  "hub-http": "/hub-http/static-1.6354",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10291",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18608",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11604",
  "I18n": "/I18n/static-7.1641",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6590",
  "payment-link-components": "/payment-link-components/static-1.23853",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7208",
  "quartz-core": "/quartz-core/static-1.6427",
  "quartz-i18n": "/quartz-i18n/static-1.883",
  "react": "/react/static-7.187",
  "react-colorpicker": "/react-colorpicker/static-2.10339",
  "react-dlb": "/react-dlb/static-1.81",
  "react-utils": "/react-utils/static-2.5441",
  "reselect": "/reselect/static-3.6",
  "rich-text-lib": "/rich-text-lib/static-1.20060",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18175",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5741",
  "UIComponents": "/UIComponents/static-3.8550",
  "foundations-assets": "/foundations-assets/static-1.5007",
  "foundations-components": "/foundations-components/static-1.8196",
  "foundations-theming": "/foundations-theming/static-1.4565",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2281",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1188",
  "quartz-config": "/quartz-config/static-1.986",
  "quartz-routing": "/quartz-routing/static-1.638",
  "quick-fetch": "/quick-fetch/static-1.4017",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-lcp-embedded-fields.3",
  "rpc-client-utils": "/rpc-client-utils/static-1.4789",
  "sanitize-text": "/sanitize-text/static-1.8279",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4892",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9668",
  "usage-tracker": "/usage-tracker/static-1.7483",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5900",
  "usage-tracker-core": "/usage-tracker-core/static-1.7333",
  "video-components-external": "/video-components-external/static-1.11718",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3499",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3485",
  "quartz-webpack": "/quartz-webpack/static-1.3432",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.286",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7811",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8059",
  "laboratory-lib": "/laboratory-lib/static-3.7284",
  "onboarding-scopes": "/onboarding-scopes/static-1.6592",
  "seat-types-lib": "/seat-types-lib/static-1.311",
  "ui-addon-opt": "/ui-addon-opt/static-4.8494",
  "HeadJS": "/HeadJS/static-2.773",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3263",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.180",
  "ts-schema": "/ts-schema/static-1.4181",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7964",
  "content-media-capture": "/content-media-capture/static-1.4925",
  "cssUtils": "/cssUtils/static-1.831",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9957",
  "file-manager-components": "/file-manager-components/static-1.23995",
  "HubStyle": "/HubStyle/static-2.11911",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10018",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11281",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9201",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10386",
  "video-data-lib": "/video-data-lib/static-1.35376",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4457",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6348",
  "customer-data-properties": "/customer-data-properties/static-1-sbelsky-fix-property-definition-memoization.2",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18781",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5213",
  "onboarding-tours": "/onboarding-tours/static-1.16855",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8228",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3723",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9200",
  "user-context": "/user-context/static-1.5240",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.848",
  "hubspotter-http": "/hubspotter-http/static-1.4750",
  "icons": "/icons/static-2.656",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.547",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.883",
  "quartz-head": "/quartz-head/static-1.873",
  "quartz-test": "/quartz-test/static-1.883",
  "quartz-tracking": "/quartz-tracking/static-1.587",
  "trellis-components": "/trellis-components/static-1.2236",
  "ui-fonts": "/ui-fonts/static-1.866",
  "usage-tracker-container": "/usage-tracker-container/static-1.7473",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9555",
  "data-token-picker": "/data-token-picker/static-1.16642",
  "FileManagerLib": "/FileManagerLib/static-1.39635",
  "property-translator": "/property-translator/static-1.5529",
  "atom": "/atom/static-1.5208",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6116",
  "salesImages": "/salesImages/static-1.527",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5679",
  "react-create-root-preference": "/react-create-root-preference/static-1.39",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1189",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4465",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.2217",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3048",
  "foundations-theming-base": "/foundations-theming-base/static-1.3550",
  "stylex": "/stylex/static-1.35",
  "interframe": "/interframe/static-3.4891",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5897",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.199",
  "chirp-fetch": "/chirp-fetch/static-1.2020",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4609",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4783",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12729",
  "content-media-compositions": "/content-media-compositions/static-2.16736",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4282",
  "magpie-lib": "/magpie-lib/static-1.5642",
  "magpie-types": "/magpie-types/static-1.5102",
  "media-bridge-lib": "/media-bridge-lib/static-1.19158",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9284",
  "avatar-components": "/avatar-components/static-1.2630",
  "calling-global-api": "/calling-global-api/static-1.64950",
  "calling-internal-common": "/calling-internal-common/static-1.31444",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66332",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58626",
  "commerce-products-lib": "/commerce-products-lib/static-1.10056",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3897",
  "crm-links": "/crm-links/static-1.6441",
  "crm-message-bus": "/crm-message-bus/static-1.43336",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4236",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13161",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9618",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8227",
  "external-options-client-types": "/external-options-client-types/static-1.4226",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7026",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.310",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5010",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3686",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3945",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4317",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.765",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3790",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49206",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4065",
  "property-value-citations": "/property-value-citations/static-1-sbelsky-fix-property-definition-memoization.2",
  "pulse": "/pulse/static-1.737",
  "smart-property-lib": "/smart-property-lib/static-1.7935",
  "tiered-pricing": "/tiered-pricing/static-1.1559",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11123",
  "zustand": "/zustand/static-1.74",
  "superstore": "/superstore/static-1.4892",
  "feedback-loader": "/feedback-loader/static-1.29543",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8837",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28928",
  "ContentUtils": "/ContentUtils/static-1.68751",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4558",
  "sassPrefix": "/sassPrefix/static-1.158",
  "react-dnd-compat": "/react-dnd-compat/static-1.4746",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1172",
  "copilot-toolkit": "/copilot-toolkit/static-1.11474",
  "navigation-messaging": "/navigation-messaging/static-1.7651",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8308",
  "growth-data-modal": "/growth-data-modal/static-1.5647",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5069",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3198",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2297",
  "navigation-components": "/navigation-components/static-1.18324",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.921",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7767",
  "ui-universal-auth": "/ui-universal-auth/static-1.9139",
  "batch-promise": "/batch-promise/static-1.1676",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17899",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10289",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5169",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1075",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "audio-components": "/audio-components/static-1.6120",
  "FileManagerCore": "/FileManagerCore/static-1.39494",
  "FileManagerImages": "/FileManagerImages/static-1.37146",
  "video-components": "/video-components/static-1.13720",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1221",
  "purchase-motions-api": "/purchase-motions-api/static-1.6119",
  "signup-constants": "/signup-constants/static-1.19186",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8190",
  "usage-tracker-public": "/usage-tracker-public/static-1.7294",
  "reactive-lib": "/reactive-lib/static-1.858",
  "simple-logging-lib": "/simple-logging-lib/static-1.3181",
  "chatspot-core": "/chatspot-core/static-1.21925",
  "calling-error-reporting": "/calling-error-reporting/static-1.31451",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11167",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6676",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1486",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7379",
  "customer-data-tracking": "/customer-data-tracking/static-1.7018",
  "commerce-permissions": "/commerce-permissions/static-1.908",
  "products-iframe-lib": "/products-iframe-lib/static-1.8296",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10673",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9637",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1222",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.145",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4104",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6931",
  "persist-promise": "/persist-promise/static-1.3833",
  "event-emitter": "/event-emitter/static-1.1082",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.469",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.240",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.415",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10374",
  "fsm": "/fsm/static-1.3864",
  "policy-lib": "/policy-lib/static-1.6919",
  "react-tinymce": "/react-tinymce/static-1.55593",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10437",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54719",
  "tinymce-plugins": "/tinymce-plugins/static-1.57833",
  "tinymce-themes": "/tinymce-themes/static-1.56689",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6711",
  "cms-field-types": "/cms-field-types/static-1.4947",
  "content-icons-ui": "/content-icons-ui/static-1.2265",
  "integrations-lib": "/integrations-lib/static-1.16572",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.450",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2198",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2325",
  "user-context-client": "/user-context-client/static-1.4711",
  "nest": "/nest/static-1.364",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.935",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4667",
  "video-embed": "/video-embed/static-1.36210",
  "social-insights-client-types": "/social-insights-client-types/static-1.22396",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36263",
  "sales-views-client-types": "/sales-views-client-types/static-1.4389",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3684",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4642",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3175",
  "tinymce-data": "/tinymce-data/static-1.40804",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5342",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12705",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11680",
  "react-codemirror": "/react-codemirror/static-1.10760",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15755",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9153",
  "flux-actions": "/flux-actions/static-1.348",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13987",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5739",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7913",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10494",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.653",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15168",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7737",
  "outpost": "/outpost/static-1.4301",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68826",
  "layout-data-lib": "/layout-data-lib/static-1.10005",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3143",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.62",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.481",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.625",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.782",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.82",
  "slack-ui-library": "/slack-ui-library/static-1.10529",
  "advanced-menus-core": "/advanced-menus-core/static-1.15348",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12257",
  "ExportDialog": "/ExportDialog/static-6.10512",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34401",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15347",
  "simple-menus-lib": "/simple-menus-lib/static-1.16864"
}
};
